import { render, staticRenderFns } from "./product-details-tag-cloud.vue?vue&type=template&id=4eec374a&scoped=true&"
import script from "./product-details-tag-cloud.vue?vue&type=script&lang=js&"
export * from "./product-details-tag-cloud.vue?vue&type=script&lang=js&"
import style0 from "./product-details-tag-cloud.vue?vue&type=style&index=0&id=4eec374a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec374a",
  null
  
)

export default component.exports